import { render, staticRenderFns } from "./MenuApp.vue?vue&type=template&id=3d4f283a&scoped=true&"
import script from "./MenuApp.vue?vue&type=script&lang=js&"
export * from "./MenuApp.vue?vue&type=script&lang=js&"
import style0 from "./MenuApp.vue?vue&type=style&index=0&id=3d4f283a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4f283a",
  null
  
)

export default component.exports